<template>
  <div class="aboutUs">
    <div class="container wrapper">
      <div class="content">
        <!-- <p>深圳刷爆网络科技有限公司是集研发与运营于一体的互联网公司。公司倡导开放、平等的工作环境、尊重、鼓励并激发员工的自主性和创造力，以肯学、肯干、协调、求变、忠诚为工作态度，以制造快乐并向全世界贩卖快乐为理念，坚持以用户至上、务实坦诚、开拓创新、快乐分享为核心价值观。公司立足于产品开发+发行运营等全方位的业务布局,立志于成为集研发、运营、发行于一身的综合性企业！</p>
        <p>可心交友隶属于深圳刷爆网络科技有限公司。是一款全民开放式移动社交应用，让你体验到完全不一样的交友方式。</p>
        <h2>主要功能：</h2>
        <p>本软件是一款真人在线视频聊天交友应用，用户可通过本软件和主播视频聊天，可进行发言， 送礼，发送私信，发动态，连麦等多种互动操作；应用结合了时下最流行的匹配模式，用户体验更好。此外用户还可以选择语音聊天，满足一些不想露脸的用户社交需求</p>
        <p>本软件主要分为广场、消息、动态、我的等4个tab。本软件技术特点在于实现的低延时的实时高清视屏传输，同时在确保画质的同时，实现视频聊天和语音聊天的效果，实时传输视频和音频，且保证同步。语音无延时，通话质量更好。</p> -->
        <p>简介：恋爱交友，就来可心交友！女生超多的陌生男女脱单交友软件！可心交友是一款集视频聊天，语音交友，恋爱社交于一身的APP。简称可心交友。通过实时语音聊天，文字互动解决陌生人社交破冰的真实恋爱社交产品。初步有所了解后，通过实时视频聊天的进一步拉进彼此距离。为上千万用户创造更多恋爱机会，打造360度恋爱圈！在可心每天都可以亲眼见证很多人的牵手幸福，也许你也是其中的一员~</p>
        <h2>【产品功能】</h2>
        <li>附近交友：快速查看附近单身男女，距离近，更方便！</li>
        <li>视频通话：直接看见对方，更真实，更直接，喜欢就大胆说出来！</li>
        <li>语音速配：语音连麦，不露脸，聊起来更畅快！</li>
        <li>动态心情：分享你的生活点滴，发现同城有趣的人！</li>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AboutUs',
  components: {
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scope>
.aboutUs {
  width: 100%;
  height: calc(100% - 154.7px);
  .container {
    height: 100%;
    padding-bottom: 110px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      position: relative;
      height: 616px;
      max-height: calc(100%);
      font-size: 23px;
      color: #333333;
      margin-top: 111px;
      p {
        text-indent: 2em;
        line-height: 36px;
      }
      li {
        line-height: 36px;
      }
      h2 {
        padding-top: 43px;
        font-size: 23px;
        line-height: 36px;
        font-weight: normal;
      }
    }
  }
}
</style>
